/**
 * Centralized Me vs Benchmark labels and colors for all dashboard visualizations.
 * Matches left-side panels: orange = Benchmark, green = Me.
 */
export const ME_COLOR = "#35c79a";
export const BENCHMARK_COLOR = "#f0825c";

export const LABEL_ME = "Me";
export const LABEL_BENCHMARK = "Benchmark";
